<template>
  <div id="landing" class="row">
    <div id="sideBar" class="">
      <!-- <b-dropdown variant="light">
        <template v-slot:button-content>
          <img width="65" height="65" src="img/arc360_icon.png">
        </template>
        <b-dropdown-item disabled>Contact Us</b-dropdown-item>
        <b-dropdown-item @click="logout">Logout</b-dropdown-item>
      </b-dropdown> -->
      <!-- <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br> -->
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <b-nav class="" vertical>
        <div class="" v-for="(item, index) in activeTabFlags">
          <b-nav-item>
            <template v-if="item.newTab">
              <b-button variant="outline-secondary" :pressed="item.value"  size="sm" class="selectedButton " v-on:click="sideBarNewTabClick(item, index)" :title="item.label">
                <b-img id="headerImage" fluid-grow :src="item.imageLink"></b-img>
              </b-button>
            </template>
            <template v-else>
              <b-button variant="outline-secondary" :pressed="item.value"  size="sm" class="selectedButton " v-on:click="sideBarClick(index)" :title="item.label">
                <b-img id="headerImage" fluid-grow :src="item.imageLink"></b-img>
              </b-button>
            </template>

          </b-nav-item>
        </div>
      </b-nav>
    </div>
    <div id="embeddedContent" class="col-11" v-for="(item, index) in Object.keys(activeTabFlags)" v-show="activeTabFlags[item].value==true">
      <!-- <template v-if="activeTabFlags[item].tabs.length > 0"> -->
      <template v-if="item == 'design_collaboration'">
        <tabs fill info type="success" tabNavClasses="tabList col-6 mr-2" tabContentClasses="" activeTab="gowrieToHelidonSection">

          <!-- <tabPane title="GIS" id="gisSection">
            <div class="description">
              <vue-friendly-iframe src="https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=ba371bb04e3f42fcb3938c24a7577e3d" className="embeddedItem" allow="*"></vue-friendly-iframe>
            </div>
          </tabPane> -->
          <tabPane title="GOWRIE TO HELIDON" id="gowrieToHelidonSection">
            <div class="description">
              <template v-show="activeDesignCollabTabFlags.gowrieToHelidonSection">
                <vue-friendly-iframe v-if="activeDesignCollabTabFlags.gowrieToHelidonSection" src="https://maps.inlandrail.com.au/g2h#/" className="embeddedItemWithTab" allow="*"></vue-friendly-iframe>
                <!-- <vue-friendly-iframe  src="https://maps.inlandrail.com.au/g2h#/" className="embeddedItemWithTab" allow="*"></vue-friendly-iframe> -->
              </template>
            </div>
          </tabPane>
          <tabPane title="HELIDON TO CALVERT" id="helidonToCalvertSection">
            <div class="description">
              <template v-show="activeDesignCollabTabFlags.helidonToCalvertSection">
                <vue-friendly-iframe v-if="activeDesignCollabTabFlags.helidonToCalvertSection" src="https://maps.inlandrail.com.au/h2c#/" className="embeddedItemWithTab" allow="*"></vue-friendly-iframe>
                <!-- <vue-friendly-iframe  src="https://maps.inlandrail.com.au/h2c#/" className="embeddedItemWithTab" allow="*"></vue-friendly-iframe> -->
              </template>
            </div>
          </tabPane>
          <tabPane title="CALVERT TO KAGARU" id="calvertToKagaruSection">
            <!-- <div class="description">
              <vue-friendly-iframe  src="https://maps.inlandrail.com.au/c2k#/" className="embeddedItem" allow="*"></vue-friendly-iframe>
            </div> -->
            <div class="description">
              <template v-show="activeDesignCollabTabFlags.calvertToKagaruSection">
                <!-- <vue-friendly-iframe src="https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=ba371bb04e3f42fcb3938c24a7577e3d" className="embeddedItemWithTab" allow="*"></vue-friendly-iframe> -->
                <vue-friendly-iframe v-if="activeDesignCollabTabFlags.calvertToKagaruSection" src="https://maps.inlandrail.com.au/c2k#/" className="embeddedItemWithTab" allow="*"></vue-friendly-iframe>
              </template>
            </div>
          </tabPane>
          <tabPane title="COMMENT" id="commentingToolSection">
            <div class="description">
              <template v-show="activeDesignCollabTabFlags.commentingToolSection">
                <vue-friendly-iframe  src="https://irsp-commenting-tool.geodemosolutions.com/" className="embeddedItemWithTab" allow="*"></vue-friendly-iframe>
              </template>
            </div>
          </tabPane>
          <!-- <tabPane title="Kagaru to Acacia Ridge and Bromelton" id="kagaruToARBSection">
            <div class="description">
              <vue-friendly-iframe src="https://maps.inlandrail.com.au/k2arb#/" className="embeddedItem" allow="*"></vue-friendly-iframe>
            </div>
          </tabPane> -->
        </tabs>
      </template>
      <template v-if="activeTabFlags[item].newTab">
          <div class="lbl_container">
            <div class ="lbl_wrapper">
              <div class="lbl_style">Redirecting to new tab</div>
            </div>
          </div>
      </template>
      <template v-else>
        <vue-friendly-iframe :src="activeTabFlags[item].link" className="embeddedItem"></vue-friendly-iframe>
      </template>
    </div>
  </div>
</template>

<script>
import tabs from '../components/Tabs/Tabs.vue';
import tabPane from  '../components/Tabs/TabPane.vue';
export default {
  name: 'MainApp',
  components: {
    tabs,
    tabPane
  },
  props: {
    activeTab: Number
  },
  data() {
    return {

    }
  },
  computed: {
    activeTabFlags: {
      get() {
        return this.$store.state.mainStore.activeTabFlags
      }
    },
    activeDesignCollabTabFlags: {
      get() {
        return this.$store.state.mainStore.activeDesignCollabTabFlags
      }
    },
  },
  methods: {
    sideBarClick(index) {
      const current = this
      // console.log(index);
      current.$store.commit("mainStore/setActiveTabFlag", index)
      // console.log(current.activeTabFlags);
      if(index == "design_collaboration"){
        current.$store.commit("mainStore/setActiveDesignCollabTabFlags", "gowrieToHelidonSection")
        var tabList = document.getElementsByClassName("tabList")[0].getElementsByTagName('a')
        if (tabList.item(0)) {
          tabList.item(0).click()
        }
      }
    },
    sideBarNewTabClick(item, index) {
      const current = this
      console.log(index);
      current.$store.commit("mainStore/setActiveTabFlag", index)
      window.open(item.link, "_blank");
    },
    logout() {
      console.log("logout clicked");
      const current = this
      current.$store.commit("mainStore/storeAccessToken", "")
      sessionStorage.removeItem("accessToken")
      current.$router.push("/")
      current.$notify({
        group: 'notification_01',
        title: 'Logout Successful',
        text: '',
        type: "success",
        duration: 1500
      });
    }
  },
  mounted() {
    var activeTabIndex = this.$router.currentRoute.params.activeTab?this.$router.currentRoute.params.activeTab:1
    // console.log(activeTabIndex);
    // console.log(this.activeTabFlags);
    var index = Object.keys(this.activeTabFlags)
    // console.log(index[activeTabIndex-1]);
    if(this.activeTabFlags[index[activeTabIndex-1]].newTab){
      this.sideBarNewTabClick(this.activeTabFlags[index[activeTabIndex-1]], index[activeTabIndex-1])
      // this.$store.commit("mainStore/setActiveDesignCollabTabFlags", "gowrieToHelidonSection")
    }
    else {
      this.sideBarClick(index[activeTabIndex-1])
    }


    // if(index == "design_collaboration"){
    //   this.$store.commit("mainStore/setActiveDesignCollabTabFlags", "gowrieToHelidonSection")
    //   var tabList = document.getElementsByClassName("tabList")[0].getElementsByTagName('a')
    //   if (tabList.item(0)) {
    //     tabList.item(0).click()
    //   }
    // }

  }
}
</script>

<style>
#landing {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  height: 93vh!important;
  width: 100vw!important;
  max-height: 100vh!important;
  background: rgba(128, 128, 128, 0.4);
  margin-left: 0;
}
#sideBar {
  /* background-color: inherit; */
  background-color: #383838;
  padding:0;
  width: 5vw;
  height: 93vh!important;
}
#embeddedContent {
  padding: 0!important;
  border: none;
  /* background: #000; */
  /* width: 98vw!important; */
}
.embeddedItem {
  height: 93vh!important;
  width: 95vw!important;
}
.embeddedItemWithTab {
  height: 88vh!important;
  width: 95vw!important;
}
.frameContainerClass {
  padding:3px!important;
  border-color: #404952;
  border-style: solid;
}
.selectedButton:hover, .selectedButton.active {
  background: rgba(240, 240, 240, 0.5)!important;
  border-color: #e36010!important;
}
/* tab custom color */
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color:  #fff !important;
    background-color: #007285 !important;
}
.nav-pills .nav-link {
    /* color:  #007285 !important; */
    color: #000 !important;
    background-color: #fff !important;
    margin: 0.5rem;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff !important;
}

.lbl_container{
display:table;
width:100%;
height: 100%;
}
.lbl_wrapper{
display:table-cell;
vertical-align:middle;
}
.lbl_style{
  text-align:center;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #fafafa;
  font-size: x-large;
}

</style>
